import React, { useEffect } from "react";
import { connect } from "react-redux";
import { orgActions } from "../../actions";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";

function OrgDetail(props) {
  const { resetOrgEdit, org, getOrgDetail, setCurrentOrgId } = props;
  const org_detail = org.org_detail;
  const org_id = props.match.params.id;

  const editicon = require("../../images/editicon.png").default;

  useEffect(() => {
    resetOrgEdit();
  }, []);

  useEffect(() => {
    setCurrentOrgId(org_id);
    getOrgDetail(org_id);
  }, [org_id])


  return (
    <div className="searchMain">
      <div className="contentContainerLeftNav">
        <div className="rightContent">
          <h3>
            {org_detail?.display_name}
            &nbsp;&nbsp;&nbsp;
            <div className="editJacketNameIcon" data-tip data-for="edit org">
              <Link
                to={{
                  pathname: "/org/" + org_detail?.org_id + "/edit",
                  state: { org_detail: org_detail },
                }}
              >
                <img src={editicon} width="16px" alt="edit" />
              </Link>
            </div>
            <ReactTooltip id="edit org" place="bottom" effect="solid" data-type="info" delayShow={300}>
              edit org
            </ReactTooltip>
          </h3>
          <div className="orgDetailTile">
            <div className="orgDetailTileHeader">
              Contact
            </div>
            <table className="ingestorFormTable">
              <tbody>
                <tr>
                  <td className="formLabel">Display Name</td>
                  <td className="formInfo">{org_detail?.display_name}</td>
                </tr>
                <tr>
                  <td className="formLabel">Legal Name</td>
                  <td className="formInfo">{org_detail?.legal_name}</td>
                </tr>
                <tr>
                  <td className="formLabel">Type</td>
                  <td className="formInfo">{org_detail?.org_type}</td>
                </tr>
                <tr>
                  <td className="formLabel">Parent Org</td>
                  <td className="formInfo">{org_detail?.parent_org_name}</td>
                </tr>
                <tr>
                  <td className="formLabel">Contact Email</td>
                  <td className="formInfo">{org_detail?.org_email}</td>
                </tr>
                <tr>
                  <td className="formLabel">Contact Phone</td>
                  <td className="formInfo">{org_detail?.org_phone}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="orgDetailTile">
            <div className="orgDetailTileHeader">
              Manifest
            </div>
            <table className="ingestorFormTable">
              <tbody>
                <tr>
                  <td className="formLabel">Enable Manifest?</td>
                  <td className="formInfo">
                    {
                      org_detail?.jotform_code && (<input type="checkbox" checked readOnly />)
                    }
                    {
                      !(org_detail?.jotform_code) && (<input type="checkbox" disabled />)
                    }
                  </td>
                </tr>

                {(org_detail?.jotform_code) &&
                  <>
                    <tr>
                      <td className="formLabel">Jotform URL</td>
                      <td className="formInfo">
                        <input
                          style={{ width: "100%" }}
                          id="joform_code"
                          name="jotform_code"
                          autoComplete="off"
                          value={org_detail?.jotform_code}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="formLabel"></td>
                      <td className="formInfo">
                        <a href={org_detail?.jotform_code} target="_blank" rel="noopener noreferrer">view manifest</a>
                      </td>
                    </tr>
                  </>
                }

              </tbody>
            </table>
          </div>

          <div className="orgDetailTile">
            <div className="orgDetailTileHeader">
              Shipping
            </div>
            <table className="ingestorFormTable">
              <tbody>
                <tr>
                  <td className="formLabel">Enable Shipping Label?</td>
                  <td className="formInfo">
                    {
                      org_detail?.allow_shipping_label && (<input type="checkbox" checked readOnly />)
                    }
                    {
                      !(org_detail?.allow_shipping_label) && (<input type="checkbox" disabled />)
                    }
                  </td>
                </tr>
                {(org_detail?.allow_shipping_label) &&
                  <>
                    <tr>
                      <td className="formLabel">Shipping Provider</td>
                      <td className="formInfo">
                        {org_detail?.shipping_provider}
                      </td>
                    </tr>
                    <tr>
                      <td className="formLabel">Shipping Address</td>
                      <td className="formInfo">
                        {org_detail?.street_1}<br />
                        {org_detail?.street_2 && (<>{org_detail?.street_2}<br /></>)}
                        {org_detail?.city}, {org_detail?.state}<br />
                        {org_detail?.zip}<br />
                      </td>
                    </tr>
                    <tr>
                      <td className="formLabel">Shipping Contact Email</td>
                      <td className="formInfo">{org_detail?.contact_email}</td>
                    </tr>
                    <tr>
                      <td className="formLabel">Shipping Contact Phone</td>
                      <td className="formInfo">{org_detail?.contact_phone}</td>
                    </tr>
                  </>
                }

              </tbody>
            </table>
          </div>

          <div className="orgDetailTile">
            <div className="orgDetailTileHeader">
              Upload
            </div>
            <table className="ingestorFormTable">
              <tbody>
                <tr>
                  <td className="formLabel">Enable Self-Serve Upload?</td>
                  <td className="formInfo">
                    {
                      org_detail?.allow_upload && (<input type="checkbox" checked readOnly />)
                    }
                    {
                      !(org_detail?.allow_upload) && (<input type="checkbox" disabled />)
                    }
                  </td>
                </tr>
                <tr>
                  <td className="formLabel">Enable Doc Type Permissioning?</td>
                  <td className="formInfo">
                    {
                      org_detail?.allow_doc_types && (<input type="checkbox" checked readOnly />)
                    }
                    {
                      !(org_detail?.allow_doc_types) && (<input type="checkbox" disabled />)
                    }
                  </td>
                </tr>
                <tr>
                  <td className="formLabel">Enable Self-Serve Addons?</td>
                  <td className="formInfo">
                    {
                      org_detail?.allow_addons && (<input type="checkbox" checked readOnly />)
                    }
                    {
                      !(org_detail?.allow_addons) && (<input type="checkbox" disabled />)
                    }
                  </td>
                </tr>
                <tr>
                  <td className="formLabel">Enable Classification Pipeline?</td>
                  <td className="formInfo">
                    {
                      org_detail?.allow_classification && (<input type="checkbox" checked readOnly />)
                    }
                    {
                      !(org_detail?.allow_classification) && (<input type="checkbox" disabled />)
                    }
                  </td>
                </tr>
                <tr>
                  <td className="formLabel">Classification Model</td>
                  <td className="formInfo">{org_detail?.model_name}</td>
                </tr>
                <tr>
                  <td className="formLabel">Allow File Splitting?</td>
                  <td className="formInfo">
                    {
                      org_detail?.allow_file_splitting && (<input type="checkbox" checked readOnly />)
                    }
                    {
                      !(org_detail?.allow_file_splitting) && (<input type="checkbox" disabled />)
                    }
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <br />
        </div>
      </div>
    </div>

  );
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const actionCreators = {
  resetOrgEdit: orgActions.resetOrgEdit,
  createOrg: orgActions.createOrg,
  getOrgTypes: orgActions.getOrgTypes,
  getOrgDetail: orgActions.getOrgDetail,
  setCurrentOrgId: orgActions.setCurrentOrgId
};

const connectedOrgDetail = connect(mapStateToProps, actionCreators)(OrgDetail);
export { connectedOrgDetail as OrgDetail };
